'use client';

import classnames from 'classnames';
import { useParams } from 'next/navigation';
import { Locale } from '@core/constants/locales.constants';
import { Route } from '@core/types/routes.types';
import { generateFullPathname } from '@utils/paths/generateFullPathname.utils';
import { usePathname } from '@navigation';
import styles from './previewBanner.module.scss';
import { PreviewBannerProps } from './previewBanner.types';

const PreviewBanner = ({
  /* props */
  classNames = [],
  nativeProps = {},
  label,
}: PreviewBannerProps) => {
  const classes = classnames([styles.previewBanner], classNames);

  const pathname = usePathname();
  const { locale, ...rest } = useParams();

  return (
    <div {...nativeProps} className={classes}>
      <a
        href={`/api/disable-preview?pathname=${generateFullPathname({ locale: locale as Locale, route: pathname as Route, params: rest })}`}
      >
        {label}
      </a>
    </div>
  );
};

export default PreviewBanner;
